import { ColumnDescription } from "react-bootstrap-table-next";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import Table from "../../../../Components/Table";
import { ListarCasoAtividadeFiltroController } from "../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import { ICasoAtividadeResponse } from "../../../../Interfaces/Geral/Historicos/HistoricoInterface";
import { MutableRefObject } from "react";
import FiltroAtividadesResumo from "./FiltroAtividadesResumo/FiltroAtividadesResumo";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";

interface IAtividadesResumo {
    dtPeriodoInicial: MutableRefObject<string>;
    dtPeriodoFinal: MutableRefObject<string>;
    categoria: string;
}

export default function AtividadesResumo(props: IAtividadesResumo) {
    const { filter, setFilter } = usePaginationFilter<{
        DT_INICIO: string;
        DT_FIM: string;
        FILTRO: string;
    }>({
        page: 1,
        filter: {
            DT_INICIO: props.dtPeriodoInicial.current,
            DT_FIM: props.dtPeriodoFinal.current,
            FILTRO: props.categoria,
        },
    });

    const {
        value: lstCasoAtividade,
        loading: lstCasoAtividadeLoading,
        // execute: updateList,
    } = useAsyncEffect(async () => {
        if (filter)
            return ListarCasoAtividadeFiltroController(
                filter?.FILTRO ?? "",
                // "2021-01-01",
                // "2024-12-31"
                filter?.DT_INICIO ?? "",
                filter?.DT_FIM ?? ""
            );
    }, [filter]);

    const gestaoVisitaColumns: Array<
        ColumnDescription<ICasoAtividadeResponse>
    > = [
        { dataField: "ID_CASO", text: "Protocolo" },
        {
            dataField: "DS_TIPO_ATIVIDADE",
            text: "Tipo de Atividade",
        },
        {
            dataField: "DT_CASO_ATIVIDADE",
            text: "Data",
            formatter: (cell) => new Date(cell).toLocaleDateString("pt-BR"),
        },
        {
            dataField: "FL_CONCLUIDO",
            text: "Concluído",
            formatter: (cell) => (cell ? "Sim" : "Não"),
        },
    ];

    function handleFilter(formData: {
        DT_INICIO: string;
        DT_FIM: string;
        FILTRO: string;
    }) {
        setFilter(formData);
    }

    return (
        <div className="card card-custom p-10">
            <div className="w-100 d-flex justify-content-between align-items-center mb-8">
                <h4>Atividades</h4>
            </div>

            <Table
                defaultStyle={{
                    align: "center",
                    classes: "p-8",
                }}
                bordered={false}
                striped
                columns={gestaoVisitaColumns}
                data={lstCasoAtividade ?? []}
                keyField="ID_CASO_ATIVIDADE"
                classes="v-middle-cells"
                wrapperClasses="mw-100 custom-scroll"
                noDataIndication={
                    <div className="text-muted text-center">
                        Não há atividades para esse período
                    </div>
                }
                loading={lstCasoAtividadeLoading}
                noSearch
            />

            <FiltroAtividadesResumo
                handleFilter={handleFilter}
                filter={filter}
            />
        </div>
    );
}
